// eslint-disable-next-line import/no-cycle
import { addDersDetails, updateDers } from '../utils/utils';
// eslint-disable-next-line import/no-cycle

export const addEditDers = async (ders) => {
  if (ders.length > 0) {
    ders.map(async (der) => {
      if (der.hasOwnProperty('Sync')) {
        if (der.Sync === 1) {
          delete der.DERNo;
        }
      }

      if (!der.hasOwnProperty('DERNo')) {
        // add product
        await addDersDetails(der);
      } else {
        // edit product
        const caseDersId = der.DERNo;
        delete der.DERNo;
        delete der.ID;
        await updateDers(caseDersId, der);
      }
    });
  }
};
